import {
	horizontalListSortingStrategy,
	SortableContext,
} from '@dnd-kit/sortable'
import type { SortingState, Table } from '@tanstack/react-table'

import { DraggableHeader } from './DraggableHeader'

interface TableHeadersProps<T> {
	table: Table<T>
	columnOrder: string[]
	sort?: string
	setSort?: (sort: string) => void
	setColSorting: (sorting: SortingState) => void
}

export function TableHeaders<T>({
	table,
	columnOrder,
	sort,
	setSort,
	setColSorting,
}: TableHeadersProps<T>) {
	return (
		<thead className="sticky m-0 top-0 grid w-fit h-[30px] z-[1]">
			{table.getHeaderGroups().map(headerGroup => (
				<tr
					key={headerGroup.id}
					className="bg-card flex w-fit h-[30px] text-[13px] border-b font-sans"
				>
					<SortableContext
						items={columnOrder}
						strategy={horizontalListSortingStrategy}
					>
						{headerGroup.headers.map(header => (
							<DraggableHeader
								key={header.id}
								header={header}
								sort={sort}
								setSort={setSort}
								setColSorting={setColSorting}
							/>
						))}
					</SortableContext>
				</tr>
			))}
		</thead>
	)
}
